import { render, staticRenderFns } from "./Contact.component.vue?vue&type=template&id=1c521f84&scoped=true&"
import script from "./Contact.component.vue?vue&type=script&lang=js&"
export * from "./Contact.component.vue?vue&type=script&lang=js&"
import style0 from "./Contact.component.vue?vue&type=style&index=0&id=1c521f84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c521f84",
  null
  
)

export default component.exports